import React, { Component } from 'react'
import { observer } from 'mobx-react'
import OtherTextInput from '../OtherTextInput'
import { parseHtmlForReact } from './../../helpers'
import { optionPrintPreview } from '../utils'
//import '../../../assets/css/checkbox.css'

@observer
class Checkbox extends Component {
    getText = () => {
        const { question, option, store } = this.props
        const { langcode } = store
        const { defaultLocale } = store.data.metadata
        const { initialLocale } = question

        let text = ''
        if (option.langs[langcode]) {
            ({ text } = option.langs[langcode])
        } else if (option.langs[defaultLocale]) {
            ({ text } = option.langs[defaultLocale])
        } else if (option.langs[initialLocale]) {
            ({ text } = option.langs[initialLocale])
        }

        // return option.langs[langcode]
        //     ? option.langs[langcode].text
        //     : option.langs[defaultLocale]
        //         ? option.langs[defaultLocale].text : ''
        return text
    }

    render() {
        const {
            option,
            question,
            store,
            other,
            mode,
            width,
            marginRight,
        } = this.props
        const { form_data, printMode } = store
        const name = `${question.id}_${option.id}`
        const optionMap = form_data.has(question.id) ? form_data.get(question.id).data : null
        const checked = optionMap && optionMap[option.id] && optionMap[option.id].checked ? true : false
        const hasOther = other ? true : false
        const otherText = hasOther && checked ?
            <OtherTextInput
                other={other}
                store={store}
                parentQuestion={question}
                option={option}
            />
            : null

        return (
            <label
                style={{ width, marginRight }}
                className={`
                    ${(checked) ? 'single-multiple-choice-con__answer--selected' : ''}
                    radius
                    single-multiple-choice-con__answer
                    checkbox
                    ${printMode ? 'printMode' : ''}
                    // ${mode === 'normal' ? 'checkbox_vertical' : 'checkbox_horizontal'}
                    ${mode === 'normal' ? 'single-multiple-choice-vertical-con__answer' : 'single-multiple-choice-horizontal-con__answer'}
            `}>
                <input type="checkbox"
                    name={name}
                    value="true"
                    id={option.id}
                    onChange={this.props.handleChange.bind(this, option)}
                    checked={checked} />
                <span className="checkmark"></span>
                {parseHtmlForReact(store.getOptionTitle(option, question))}
                { printMode ? optionPrintPreview(option) : null }
                {otherText}
            </label>
        )
    }
}

export default Checkbox
